const Role = {
	Teacher: "Enseignant",
	User: "Étudiant",
	Admin: "Administrateur",
	AdminContact: "Contact Administrateur",
	Guest: "guest"
}

export const RoleIds = {
	Admin: 1,
	AdminContact: 2,
	Teacher: 3,
	Student: 4
}

export default Role;